export default __webpack_public_path__ + "static/media/coin-vertical.d1aab264.png";